<template>
  <div>
    <div class="d-flex align-items-center mb-3 p-0">
      <div class="d-flex align-items-center">
        <span class="sectionTitle">اطلاعات کاربر</span>
      </div>
      <div class="line"></div>
    </div>
    <div class="section row">
      <b-col cols="12" md="6">
        <div class="mb-3">
          <BaseText @input="addFactorData.firstName = $event" :value="addFactorData.firstName" title="نام" placeholder="نام" />
        </div>
        <div class="mb-3">
          <BaseText @input="addFactorData.enFirstName = $event" :value="addFactorData.enFirstName" title="Name" placeholder="Name" />
        </div>
        <div class="mb-3">
          <BaseText inputType="number" disable :maxlength="14" @input="addFactorData.mobile = $event" :value="addFactorData.mobile" title="تلفن همراه" placeholder="تلفن همراه" />
        </div>
        <div class="mb-3">
          <BaseText inputType="number" :maxlength="10" @input="addFactorData.nationalCode = $event" :value="addFactorData.nationalCode" title="کد ملی" placeholder="کد ملی" />
        </div>
        <div class="mb-3">
          <BaseText @input="addFactorData.fatherName = $event" :value="addFactorData.fatherName" title="نام پدر" placeholder="نام پدر" />
        </div>
        <div class="mb-3">
          <BaseText @input="addFactorData.fieldOfStudy = $event" :value="addFactorData.fieldOfStudy" title="رشته" placeholder="رشته" />
        </div>
      </b-col>
      <b-col cols="12" md="6">
        <div class="mb-3">
          <BaseText @input="addFactorData.lastName = $event" :value="addFactorData.lastName" title="نام خانوادگی" placeholder="نام خانوادگی" />
        </div>
        <div class="mb-3">
          <BaseText @input="addFactorData.enLastName = $event" :value="addFactorData.enLastName" title="Last Name" placeholder="Last Name" />
        </div>
        <div class="mb-3">
          <BaseText inputType="number" :maxlength="14" @input="addFactorData.telephone = $event" :value="addFactorData.telephone" title="تلفن ثابت" placeholder="تلفن ثابت" />
        </div>
        <div class="mb-3">
          <DateTimeOffset :value="addFactorData.birthDate" @input="addFactorData.birthDate = $event" title="تاریخ تولد" placeholder="تاریخ تولد" :hasDefaultDate="false" />
        </div>
        <div class="mb-3">
          <BaseText inputType="text" @input="addFactorData.job = $event" :value="addFactorData.job" title="شغل" placeholder="شغل" />
        </div>
        <div class="mb-3">
          <BaseText inputType="text" @input="addFactorData.educationRate = $event" :value="addFactorData.educationRate" title="میزان تحصیلات" placeholder="میزان تحصیلات" />
        </div>
      </b-col>
      <div class="">
        <BaseText @input="addFactorData.email = $event" :value="addFactorData.email" title="ایمیل" placeholder="ایمیل" />
      </div>
    </div>
    <div class="d-flex align-items-center mb-3 p-0">
      <div class="d-flex align-items-center">
        <span class="sectionTitle">اطلاعات پستی</span>
      </div>
      <div class="line"></div>
    </div>
    <div class="section">
      <b-row class="mb-3">
        <b-col>
          <BaseText inputType="text" :maxlength="100" :value="addFactorData.province" @input="addFactorData.province = $event" title="استان" placeholder="استان" />
        </b-col>
        <b-col>
          <BaseText inputType="text" :maxlength="100" :value="addFactorData.city" @input="addFactorData.city = $event" title="شهر" placeholder="شهر" />
        </b-col>
      </b-row>
      <div class="mb-3">
        <TextAreaInput :value="addFactorData.address.addressText" @input="addFactorData.address.addressText = $event" title="آدرس" placeholder="آدرس" />
      </div>
      <div>
        <BaseText
          :value="addFactorData.address.postalCode"
          :maxlength="10"
          @input="addFactorData.address.postalCode = $event"
          inputType="number"
          title="کد پستی"
          placeholder="کد پستی"
        />
      </div>
      <div></div>
    </div>
    <div>
      <div class="d-flex align-items-center mb-3 p-0">
        <div class="d-flex align-items-center">
          <span class="sectionTitle">اطلاعات تکمیلی</span>
        </div>
        <div class="line"></div>
      </div>
      <div class="inner__style">
        <div v-if="!addFactorData.nationalCodeImage" class="upload-photo-icon d-flex mx-auto justify-content-center align-items-center" @click="$bvModal.show('cropperModal')">
          <div>
            <i class="fas fa-cloud-upload-alt icon-size"></i>
            <div class="upload-text-size">برای آپلود عکس خود کلیک کنید</div>
          </div>
        </div>
        <div v-else class="grand-parent">
          <div class="upload-photo-parent">
            <div class="uploaded-photo">
              <div class="remove-icon" @click="addFactorData.nationalCodeImage = ''">
                <i class="fa fa-times"></i>
              </div>
              <div @click="downloadHandle(addFactorData.nationalCodeImage)" class="download">
                <img class="previewImage" :src="addFactorData.nationalCodeImage" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex align-items-center mb-3 p-0">
      <div class="d-flex align-items-center">
        <span class="sectionTitle">یادداشت</span>
      </div>
      <div class="line"></div>
    </div>
    <div class="section">
      <div>
        <TextAreaInput :value="addFactorData.adminNote" @input="addFactorData.adminNote = $event" title="یادداشت" placeholder="یادداشت" />
      </div>
    </div>
    <b-row class="mb-3">
      <b-col class="deactiveUser" lg="4">
        <b-form-checkbox id="checkbox-1" v-model="deactiveUserStatus" @change="deactiveUser" name="checkbox-1"> غیرفعال کردن کاربر </b-form-checkbox>
      </b-col>
      <b-col lg="8">
        <div class="buttonClass">
          <div @click="addFactor">
            <Button :loading="submitLoading" text="ثبت" btnClass="aprove btn-border" />
          </div>
        </div>
      </b-col>
    </b-row>
    <b-modal id="cropperModal" no-close-on-esc hide-footer centered size="md" header-close-variant="dark" cancel-title>
      <template #modal-title>کراپ عکس</template>
      <div class="p-3">
        <ImageCropper :cropperLoading="cropperLoading" @imageSourceChanged="uploadImage($event)" :cropSize="imageCrop" cropShape="rectangle-stencil" />
      </div>
    </b-modal>
  </div>
</template>

<script>
import BaseText from '../../common/form/formModules/BaseText.vue'
import TextAreaInput from '../../common/form/formModules/TextAreaInput.vue'
import { invoiceMixins } from '../../../utils/mixins'
import Button from '../../common/Button.vue'
import invoiceDataProvider from '../../../services/invoice'
import userDataProvider from '../../../services/user'
import fileMannager from '../../../services/file'
import DateTimeOffset from '../../common/form/formModules/DateTimeOffset.vue'
import ImageCropper from '../../user/ImageCropper.vue'
import axios from 'axios'
export default {
  name: 'user-information-form',
  mixins: [invoiceMixins],
  components: {
    BaseText,
    TextAreaInput,
    Button,
    DateTimeOffset,
    ImageCropper,
  },
  data() {
    return {
      imageCrop: { width: 400, height: 200 },
      cropperLoading: false,
      selectProvince: '',
      selectCity: '',
      phoneResponseText: '',
      phoneError: false,
      phoneResponseErr: false,
      lastNameError: false,
      nameError: false,
      resetCityFlag: true,
      submitLoading: false,
      allowSubmit: true,
      forceUpdateFlag: true,
      deactiveUserStatus: false,
      searchedProvinceData: [],
      searchedCityData: [],
      addFactorData: {
        firstName: '',
        enFirstName: '',
        nationalCodeImage: '',
        lastName: '',
        enLastName: '',
        nationalCode: '',
        mobile: '',
        job: '',
        province: '',
        city: '',
        fieldOfStudy: '',
        birthDate: '',
        telephone: '',
        fatherName: '',
        educationRate: '',
        adminNote: '',
        address: {
          cityId: '',
          addressText: '',
          postalCode: '',
        },
      },
    }
  },
  watch: {
    'addFactorData.birthDate'(c) {
      if (!c.includes('T') && c) {
        this.addFactorData.birthDate = this.addFactorData.birthDate.replaceAll('/', '-') + 'T00:00:00.000Z'
      }
    },
  },
  beforeMount() {
    this.forceUpdateFlag = false
    // this.$nextTick(() => {
    //   invoiceDataProvider
    //     .getProvince({
    //       pageSize: 1000,
    //       pageNumber: 1,
    //       keyword: '',
    //     })
    //     .then((res) => {
    //       this.$store.dispatch('invoice/setProvinceData', res.data.data)
    //       this.searchedProvinceData = this.provinceData
    //     })
    //   this.forceUpdateFlag = true
    // })
    userDataProvider
      .getUserDetails({
        peopleId: this.$route.params.id,
      })
      .then((res) => {
        const peopleData = res.data.data.peopleGlobalDto
        this.addFactorData.firstName = peopleData.firstName
        this.addFactorData.lastName = peopleData.lastName
        this.addFactorData.mobile = peopleData.mobile
        this.addFactorData.email = peopleData.email
        this.addFactorData.telephone = peopleData.telephone
        this.addFactorData.adminNote = peopleData.adminNote
        this.addFactorData.address.addressText = peopleData.address.addressText
        this.addFactorData.address.cityId = +peopleData.address.cityId
        this.addFactorData.address.postalCode = peopleData.address.postalCode
        this.addFactorData.nationalCode = peopleData.nationalCode
        this.addFactorData.enFirstName = peopleData.enFirstName
        this.addFactorData.enLastName = peopleData.enLastName
        this.addFactorData.fatherName = peopleData.fatherName
        this.addFactorData.job = peopleData.job
        this.addFactorData.fieldOfStudy = peopleData.fieldOfStudy
        this.addFactorData.city = peopleData.city
        this.addFactorData.province = peopleData.province
        this.addFactorData.educationRate = peopleData.educationRate
        this.addFactorData.birthDate = peopleData.birthDate
        this.addFactorData.nationalCodeImage = peopleData.nationalCodeImage
        this.deactiveUserStatus = peopleData.isDeactivate
      })
  },

  methods: {
    async downloadHandle(link) {
      await axios
        .get(link, {
          responseType: 'arraybuffer',
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: 'image/jpeg' })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.download = this.addFactorData.firstName + ' ' + this.addFactorData.lastName + '.jpg'
          document.body.appendChild(link)

          link.dispatchEvent(
            new MouseEvent('click', {
              bubbles: true,
              cancelable: true,
              view: window,
            }),
          )

          URL.revokeObjectURL(url)
          document.body.removeChild(link)
        })
    },
    addFactor() {
      this.phoneError = false
      this.lastNameError = false
      this.nameError = false
      this.$emit('goUp', false)
      if (!this.addFactorData.firstName) {
        this.$emit('goUp', true)
        this.nameError = true
      }
      if (!this.addFactorData.lastName) {
        this.$emit('goUp', true)
        this.lastNameError = true
      }
      if (!this.addFactorData.mobile) {
        this.$emit('goUp', true)
        this.phoneError = true
        return
      } else {
        if (this.allowSubmit && this.addFactorData.firstName && this.addFactorData.lastName && this.addFactorData.mobile) {
          this.submitLoading = true
          this.allowSubmit = false
          invoiceDataProvider
            .updatePeople({
              id: this.$route.params.id,
              firstName: this.addFactorData.firstName,
              lastName: this.addFactorData.lastName,
              mobile: this.addFactorData.mobile,
              email: this.addFactorData.email,
              telephone: this.addFactorData.telephone,
              adminNote: this.addFactorData.adminNote,
              nationalCode: this.addFactorData.nationalCode,
              enFirstName: this.addFactorData.enFirstName,
              enLastName: this.addFactorData.enLastName,
              nationalCodeImage: this.addFactorData.nationalCodeImage,
              fatherName: this.addFactorData.fatherName,
              job: this.addFactorData.job,
              fieldOfStudy: this.addFactorData.fieldOfStudy,
              educationRate: this.addFactorData.educationRate,
              birthDate: this.addFactorData.birthDate ? this.addFactorData.birthDate : null,
              province: this.addFactorData.province,
              city: this.addFactorData.city,

              address: {
                cityId: +this.addFactorData.address.cityId,
                addressText: this.addFactorData.address.addressText,
                postalCode: this.addFactorData.address.postalCode,
              },
            })
            .then((res) => {
              this.submitLoading = false
              this.phoneResponseErr = false
              this.allowSubmit = true
              this.$emit('userUpdated', true)
            })
            .catch((err) => {
              if (err.response.status == 409) {
                this.$emit('goUp', true)
                this.phoneResponseErr = true
                this.submitLoading = false
                this.allowSubmit = true
                this.phoneResponseText = err.response.data.message
              }
            })
        }
      }
    },
    async uploadImage(e) {
      this.cropperLoading = true
      const req = await fileMannager.addImage({
        base64image: e,
      })
      this.addFactorData.nationalCodeImage = req.data.data.downloadUrl
      this.cropperLoading = false
      this.$bvModal.hide('cropperModal')
    },
    deactiveUser() {
      this.deactiveUserStatus == !this.deactiveUserStatus
      setTimeout(() => {
        invoiceDataProvider.deactivePeople({
          peopleId: this.$route.params.id,
          deactiveState: this.deactiveUserStatus,
        })
      }, 100)
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .custom-control-label {
  margin-right: 5px;
}
::v-deep .custom-checkbox .custom-control-input {
  border-radius: 4px;
}
::v-deep .custom-checkbox .custom-control-input:checked {
  opacity: 0.5;
}
::v-deep .custom-checkbox .custom-control-input:checked + .custom-control-label {
  opacity: 0.5;
}
.sectionTitle {
  white-space: nowrap;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  text-align: right;
  color: #556ee6;
}
.button-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.deleteButton {
  padding: 6px 5px 6px 10px;
  display: flex;
  margin-left: 10px;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  line-height: 23px;
  background: #ffffff;
  border: 1px solid #74788d;
  box-sizing: border-box;
  border-radius: 4px;
}
.deleteTitle {
  color: gray;
  margin-right: 5px;
}
.cancel {
  background-color: rgba(51, 51, 51, 0.6) !important;
}
.btn-border {
  border-radius: 4px !important;
}
.aprove {
  background-color: #556ee6 !important;
  width: 119px !important;
}
.line {
  width: 100%;
  margin-right: 20px;
  height: 2px;
  background: #eaeaea;
  border-radius: 10px;
}
.invoice-disable {
  color: rgba(73, 80, 87, 0.4) !important;
  span {
    color: rgba(73, 80, 87, 0.4) !important;
  }
}
.__item {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0px;
}
.section {
  padding: 26px 30px;
  margin-bottom: 20px;
  background: #f8f9fa;
  border-radius: 6px;
}
.button-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.cancel {
  background-color: rgba(51, 51, 51, 0.6) !important;
}
.btn-border {
  border-radius: 4px !important;
}
.aprove {
  background-color: #556ee6 !important;
  width: 119px !important;
}
.deactiveUser {
  display: flex;
  align-items: center !important;
  padding-right: 0;
}
.buttonClass {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  direction: ltr;
}
.submitButton {
  font-size: 14px;
  padding: 8px 45px;
  color: white;
  background: #556ee6;
  border: 1px solid #556ee6;
  box-sizing: border-box;
  border-radius: 4px;
}
.cancleButton {
  display: flex;
  margin-left: 10px;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  line-height: 23px;
  background: #74788d;
  box-sizing: border-box;
  border-radius: 4px;
}
.deleteTitle {
  color: gray;
  margin-right: 5px;
}
.error-wrapper {
  text-align: center;
  * {
    color: #4a4a4a;
    font-style: normal;
    font-weight: normal;
  }

  .error-title {
    font-size: 16px;
    margin-bottom: 40px;
    line-height: 23px;
  }

  .error-text {
    font-size: 14px;
    line-height: 20px;
    margin: 25px 0;
  }
  button {
    font-size: 16px;
    line-height: 23px;
    background-color: transparent;
    outline: none;
    border: none;
  }
  .buttons {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .approveButton {
    padding: 6px 90px;
    color: white;
    background: #556ee6;
    border-radius: 4px;
  }
  .cancelButton {
    padding: 6px 90px !important;
    margin-left: 12px !important;
    color: white !important;
    background: #74788d !important;
    border-radius: 4px !important;
  }
}
.inner__style {
  background-color: white;
  padding: 23px;
}

.uploaded-photo-main {
  display: flex;
}
.uploaded-photo {
  height: 220px !important;
  width: 160px;
  position: relative;
  margin-left: 10px;
  img {
    width: 100%;
    height: 100%;
  }
}

.inner__style {
  background-color: white;
  padding: 23px;
}

.uploaded-photo {
  width: 243px;
  height: 157px;
  position: relative;
  img {
    width: 100%;
    height: 100%;
  }
}
.remove-icon {
  position: absolute;
  top: 5px;
  left: 5px;
  background-color: gray;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  i {
    color: white;
    // font-size: 20px;
  }
}
.upload-text-size {
  font-size: 18px;
  text-align: center;
  margin-top: 10px;
  color: #495057;
}
.icon-size {
  font-size: 45px;
  text-align: center;
  display: block;
  color: #74788d;
}

.upload-photo-icon {
  height: 250px;
  width: 100%;
  border: 2px dashed #ced4da;
  border-radius: 8px;
  cursor: pointer;
}
.grand-parent {
  padding: 20px;
  border: 2px dashed #ced4da;
  justify-content: right;
  display: flex;
  align-items: right;
  position: relative;
}
.activeImageClass {
  border: 3px solid #556ee6;
  border-radius: 5px;
}
.remove-field-link {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  cursor: pointer;
  i {
    // font-size: 18px;
    color: #ff4861;
    // font-weight: 100;
  }
}
.previewImage {
  border-radius: 4px;
}

.download {
  cursor: pointer;
  height: 220px !important;
}
</style>
